/* istanbul ignore file */
import { makeFragmentData } from '@packages/gql/generated/shopping';
import type { ProductVariationFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import { ProductVariationFragmentFragmentDoc } from '@packages/gql/generated/shopping/graphql';
import { getBonusPointsFragmentedData } from '../BonusPoints/mockdata';
import { getTaxHintFragmentedData } from '../TaxHint/mockdata';
import {
  articleServicesCurrencyDataMock,
  getArticleServicesFragmentedData,
} from '../ArticleServices/mockdata';
import { productPriceDataMock } from '../Price/mockdata';
import { voucherPriceDataMock } from '../VoucherPrice/mockdata';
import { getInstallmentCalculatorCallToActionFragmentedData } from '../InstallmentCalculator/InstallmentCalculatorCallToAction/mockdata';
import { variationSelectDataMock } from '../VariationSelect/mockdata';
import { getOocvTableFragmentedData } from '../OocvTable/mockdata';
import { getRatingIconsVerifiedFragmentedData } from '../RatingIconsVerified/mockdata';
import { imageGalleryDataMock } from '../ImageGallery/mockdata';
import { trackingDataMock } from '../Tracking/mockdata';
import { imageGalleryColorDialogDataMock } from '../ImageGallery/ImageGalleryColorDialog/mockdata';
import { deliveryInfoCardDataMock } from '../DeliveryInfoCard/mockdata';
import { efficiencyFlagListDataMock } from '../EfficiencyFlagList/mockdata';
import { sampleOrderLinkDataMock } from '../SampleOrderLink/mockdata';
import { ecoLabelCardDataMock } from '../EcoLabelCard/mockdata';
import { downloadsCardDataMock } from '../DownloadsCard/mockdata';
import { legalHintsCardDataMock } from '../LegalHintsCard/mockdata';
import { productHintsCardDataMock } from '../ProductHintsCard/mockdata';
import { productHeadlineDataMock } from '../ProductHeadline/mockdata';
import { loadbeeDataMock } from '../LoadbeeCard/mockdata';
import { addToBasketButtonDataMock } from '../AddToBasketButton/mockdata';
import { recommendationsDataMock } from '../Recommendations/mockdata';
import { similarProductsDataMock } from '../SimilarProducts/mockdata';
import { compactProductDataMock } from '../CompactProduct/mockdata';

export const productVariationDataMock: ProductVariationFragmentFragment = {
  ' $fragmentRefs': {
    ImageGalleryFragmentFragment: imageGalleryDataMock,
    TrackingFragmentFragment: trackingDataMock,
    ImageGalleryColorDialogFragmentFragment: imageGalleryColorDialogDataMock,
    DeliveryInfoCardFragmentFragment: deliveryInfoCardDataMock,
    EfficiencyFlagListFragmentFragment: efficiencyFlagListDataMock,
    SampleOrderLinkFragmentFragment: sampleOrderLinkDataMock,
    EcoLabelCardFragmentFragment: ecoLabelCardDataMock,
    DownloadsCardFragmentFragment: downloadsCardDataMock,
    LegalHintsCardFragmentFragment: legalHintsCardDataMock,
    ProductHintsCardFragmentFragment: productHintsCardDataMock,
    HeadlineFragmentFragment: productHeadlineDataMock,
    LoadbeeFragmentFragment: loadbeeDataMock,
    AddToBasketFragmentFragment: addToBasketButtonDataMock,
    RecommendationsFragmentFragment: recommendationsDataMock,
    SimilarRecoFragmentFragment: similarProductsDataMock,
    CompactProductFragmentFragment: compactProductDataMock,
  },
  akl: 'AKLBB761176388',
  sku: '9669202279-40-761176388',
  name: 'Nike Sportswear Sneaker »Air Max Ltd 3«',
  orderNumber: '96692022',
  bonuspoints: getBonusPointsFragmentedData(),
  delivery: {
    deliverySize: 'S',
    ...getTaxHintFragmentedData(),
  },
  availability: {
    message: 'lieferbar in 2-3 Wochen',
    state: 'AVAILABLE',
  },
  price: {
    value: 13999,
    valueOld: null,
    currency: 'EUR',
    ' $fragmentRefs': {
      ArticleServicesCurrencyFragmentFragment: articleServicesCurrencyDataMock,
      ProductPriceFragmentFragment: productPriceDataMock,
      VoucherPriceFragmentFragment: voucherPriceDataMock,
    },
  },
  sizeHint: 'Fällt klein aus, bitte eine Größe größer bestellen',
  tireEfficiency: {
    flags: [
      {
        level: 'A',
        type: 'WETGRIP',
      },
    ],
    link: 'link',
  },
  powerEfficiencyFlags: [
    {
      color: 'darkgreen',
      hasOldLabel: false,
      level: 'A',
      link: 'https://bilder.baur.de/i/empiriecom/cbcbc5afc634fedd958c6942405aded2.jpg',
      text: 'test',
    },
  ],
  installment: {
    ...getInstallmentCalculatorCallToActionFragmentedData(),
    numberOfInstallments: 12,
  },
  dimensions: [
    {
      ' $fragmentRefs': {
        DimensionFragmentFragment: variationSelectDataMock,
      },
      values: [
        {
          displayText: 'schwarz',
        },
        {
          displayText: 'weiß',
        },
      ],
    },
  ],
  sampleOrderType: 'WOOD',
  itemOptionCommKey: null,
  hasServices: false,
  aplus: getArticleServicesFragmentedData(),
  oocv: [getOocvTableFragmentedData()],
  seoRatingIcons: {
    product: getRatingIconsVerifiedFragmentedData(),
  },
  sellingPoints: [
    '138 cm (55"), Ultra HD 4K, Curved-LED-Fernseher',
    'Smart TV, HbbTV, HDR, Google Assistant, Alexa',
    'Triple Tuner (DVB-T2 HD/S2/C), PQI 1500 (Picture Quality Index)',
    'WLAN, Bluetooth, DLNA, 3x HDMI, 2x USB, CI+ Modul-Schacht',
    'Apple TV und Airplay 2 direkt im Samsung Smart Hub eingebunden',
  ],
  longDescription:
    'Ultra scharfes Bild mit dem 4K UHD TV. Durch die viermal höhere Auflösung als Full HD sehen Sie stets gestochen scharfe Bilder. Die 3840 x 2160 Pixel sorgen für ein ultimatives Fernseherlebnis.',
};

export function getProductVariationFragmentedData(data?: ProductVariationFragmentFragment) {
  return makeFragmentData(data || productVariationDataMock, ProductVariationFragmentFragmentDoc);
}
